/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { onValidateLoginTokenLogout } from '../../Store/Slices/validateLoginTokenSlice'
import Loader from '../../Components/Loader/Loader'
import { onGenerateTokenSubmitFullReset } from '../../Store/Slices/generateTokenSlice'
import { clearBreadcrumbsOnLogout } from '../../Utils/breadcrumbUtils'
import axiosInstance from '../../Common/Axios/axiosInstance'
import API from '../../Common/Endpoint/serviceConstrants'

const Logout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const V3Data = useSelector((state) => state.cardDataSliceReducer);
    // const V3DataUrl = new URL(V3Data?.SignInUrl).origin;



    let V3DataUrl = "";
    if (V3Data?.SignInUrl) {
        try {
            V3DataUrl = new URL(V3Data.SignInUrl, window.location.origin).origin;
        } catch (e) {
            console.error("Invalid URL:", V3Data.SignInUrl, e);
        }
    }

    useEffect(() => {
        const logout = async () => {

        if (sessionStorage.getItem("login")) {
            clearBreadcrumbsOnLogout();
            sessionStorage.removeItem("login");
            sessionStorage.removeItem("activityExpiryTime");
            localStorage.setItem("contactUs_reloaded", 'false');
            localStorage.setItem("logout", Date.now().toString());
            dispatch(onGenerateTokenSubmitFullReset());
            try {
                await axiosInstance.post(API.member_session_logout, {}, { withCredentials: true });
            } finally {
                // Clear the locally cached Validate Login Token response and xid
                // after the server-side Redis member session has been revoked.
                dispatch(onValidateLoginTokenLogout())
                window.location.href = `${V3DataUrl}/Logout/${V3Data?.integrationId}/${sessionStorage.getItem("loginSessionToken")}`;
            }
        } else {
            navigate("/")
        }
        }
        logout();
    }, [])

    return (
        <>
            <Loader />
        </>
    )
}

export default Logout
